import { useEffect } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import RecruitHero from "./components/RecruitHero";
import RecruitBenefits from "./components/RecruitBenefits";
import RecruitForm from "./components/RecruitForm";

export default function RecruitPage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || "";

    const schema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "直播主招募｜娛樂紅歡密 Rappy me",
      "description": "娛樂紅歡密招募直播主！有才藝（歌唱、舞蹈、樂器）或愛聊天、愛分享的你，零經驗也能上手，提供專業培訓與流量扶持，立即應徵加入台中最活躍的直播團隊。",
      "url": `${siteUrl}/recruit`,
      "inLanguage": "zh-TW",
      "isPartOf": {
        "@type": "WebSite",
        "name": "娛樂紅歡密 Rappy me",
        "url": siteUrl,
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首頁",
            "item": siteUrl,
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "直播主招募",
            "item": `${siteUrl}/recruit`,
          },
        ],
      },
      "mainEntity": {
        "@type": "JobPosting",
        "title": "直播主",
        "description": "娛樂紅歡密招募直播主，有才藝或愛聊天分享的你都歡迎！零經驗可，提供專業培訓與流量扶持。",
        "hiringOrganization": {
          "@type": "Organization",
          "name": "娛樂紅歡密 Rappy me",
          "url": siteUrl,
          "sameAs": [
            "https://www.instagram.com/rappy.meme/",
            "https://www.facebook.com/Red.shrimp.close/",
          ],
        },
        "jobLocation": {
          "@type": "Place",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "台中市",
            "addressCountry": "TW",
          },
        },
        "employmentType": "PART_TIME",
        "datePosted": "2026-04-10",
      },
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-recruit";
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    document.title = "直播主招募｜娛樂紅歡密 Rappy me｜台中直播團隊徵才";

    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content") || "";
    if (metaDesc) {
      metaDesc.setAttribute("content", "娛樂紅歡密招募直播主！有才藝（歌唱、舞蹈、樂器）或愛聊天、愛分享的你，零經驗也能上手，提供專業培訓與流量扶持，立即應徵加入台中最活躍的直播團隊。");
    }

    return () => {
      const el = document.getElementById("schema-recruit");
      if (el) el.remove();
      document.title = "娛樂紅歡密 Rappy me｜台中台灣露營聯誼活動策劃平台｜讀書會親子營";
      if (metaDesc) {
        metaDesc.setAttribute("content", prevDesc);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <RecruitHero />
      <RecruitBenefits />
      <RecruitForm />
      <Footer />
    </div>
  );
}
